import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AuthModal from './AuthModal';
import './AuthLanding.scss';

export default function AuthLanding({ onAuthSuccess }) {
  const [mode, setMode] = useState(null);   // null | 'login' | 'create'

  return (
    <div className="auth-landing">
      {!mode && (
        <>
          <button className="ghost-btn" onClick={() => setMode('login')}>
            LOGIN
          </button>

          {/* <span className="or">or</span> */}

           {/* onClick={() => setMode('create')}> */}
          {/* <button className="ghost-btn"  disabled>
            CREATE&nbsp;ACCOUNT
          </button> */}
        </>
      )}

      {mode && (
        <AuthModal
          mode={mode}
          onClose={() => setMode(null)}
          onSuccess={() => {
            onAuthSuccess();   // bubbles to App.jsx
            setMode(null);
          }}
        />
      )}
    </div>
  );
}

AuthLanding.propTypes = { onAuthSuccess: PropTypes.func.isRequired };
